import React from 'react';
import styled from 'styled-components';
import ButtonLink from '../components/global/button-link';
import SEO from '../components/global/seo';

const Styled404 = styled.div`
	min-height: calc(100vh - 28.8rem);
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	.text-container {
		padding: 4rem 2rem;
		color: #fff;
	}
	p {
		margin: 1rem 1rem 3rem;
	}
	a {
		line-height: 1.2rem;
		padding: 0.5rem 2rem;
		@media all and (max-width: 336px) {
			border-radius: 15px;
		}
	}
`;

const NotFoundTemplate = () => {
	return (
		<Styled404>
			<SEO title="Page not found" />
			<div className="text-container">
				<h1>The page you are looking for is not found.</h1>
				<p>Looks like the content you're looking for is no longer here.</p>
				<ButtonLink to="/" bg="teal">
					BACK TO HOMEPAGE
				</ButtonLink>
			</div>
		</Styled404>
	);
};

export default NotFoundTemplate;
